module.exports = __webpack_public_path__ + "static/palaka-d742d64152b12a701d7550d05f2bf4b6.png";